import TrackListPage from "components/Admin/Batches/List/Track/BatchTrack"
import React from "react"

const ListPage = () => {
    return (
        <React.Fragment>
            <TrackListPage />
        </React.Fragment>
    )
}
export default ListPage
